/* Views */
import {BadgeSelector} from './views/BadgeSelector.js';
import {ProjectOverview} from './views/ProjectOverview.js';
import {GlobalView} from './views/GlobalView.js';
import {BranchDetails} from './views/BranchDetails.js';

import './App.css';

/* common */
import React, { Component } from 'react';

/*
 * I got created in a flight from Da Nang to Ha Noi to be a
 * cheap ass router to release this product. Will you see this
 * class in the years to come?
 */
class AppDispatcher extends Component {
  constructor(props) {
    super(props)
    var pathname = window.location.pathname;

    if (pathname.includes("/r/gh/"))
      this.state = this.selectGithubView(props);
    else if (pathname === "/oldsite")
      this.state = {route: "GlobalView"}
    else
      this.state = {}
  }

  selectGithubView(props) {
    var project = window.location.pathname.substring(6);
    var parts = project.split('/');
    if (parts.length > 2) {
      /* TODO.. properly turn the search into an object */
      project = parts.slice(0, 2).join('/');
      var branch = parts.slice(2).join('/');
      var ci = "travis-ci";
      var subNumber = 1;
      var buildId;
      const ciIndex = window.location.search.indexOf("ci=");
      if (ciIndex > 0)
        ci = window.location.search.substring(ciIndex + 3).split('&')[0];
      const subIndex = window.location.search.indexOf("subNumber=");
      if (subIndex > 0)
        subNumber = Number(window.location.search.substring(subIndex + 10).split('&')[0]);
      const buildIdIndex = window.location.search.indexOf("buildId=");
      if (buildIdIndex > 0)
        buildId = Number(window.location.search.substring(buildIdIndex + 8).split('&')[0]);
      return {
                      route: "BranchDetails",
                      hosting: "github",
                      project: project,
                      branch: branch,
                      ci_system: ci,
                      sub_number: subNumber,
                      build_id: buildId
      };
    } else {
      return {route: "ProjectOverview", hosting: "github", project: project}
    }
  }

  render() {
    if (this.state.route === "BranchDetails")
      return <BranchDetails hosting={this.state.hosting} project={this.state.project} branch={this.state.branch} ci_system={this.state.ci_system} sub_number={this.state.sub_number} build_id={this.state.build_id}/>
    if (this.state.route === "ProjectOverview")
      return <ProjectOverview hosting={this.state.hosting} project={this.state.project}/>;
    if (this.state.route === "GlobalView")
      return <GlobalView/>;
    return <BadgeSelector/>;
  }
}

export default AppDispatcher;



// WEBPACK FOOTER //
// ./src/App.js